import { NavLink, useNavigate } from 'react-router-dom'
import { LayoutDashboard, Users, Briefcase, Settings, LogOut, Zap } from 'lucide-react'
import { signOut } from 'firebase/auth'
import { auth } from '@/lib/firebase'
import { useWorkspaceStore } from '@/store/workspace'

const NAV = [
    { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { to: '/applications', label: 'Applications', icon: Users },
    { to: '/jobs', label: 'Jobs', icon: Briefcase },
    { to: '/settings', label: 'Settings', icon: Settings },
]

export default function Sidebar() {
    const { workspaceName, plan } = useWorkspaceStore()
    const navigate = useNavigate()

    async function handleLogout() {
        await signOut(auth)
        navigate('/login')
    }

    return (
        <nav className="sidebar">
            {/* Logo */}
            <div className="sidebar-logo">
                <div className="sidebar-logo-icon">⚡</div>
                <div>
                    <div className="sidebar-logo-text">HRX<span>Agent</span></div>
                </div>
            </div>

            {/* Workspace info */}
            {workspaceName && (
                <div style={{ padding: '8px 12px 12px', borderBottom: '1px solid var(--border)', marginBottom: 8 }}>
                    <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 2 }}>Workspace</div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text)', display: 'flex', alignItems: 'center', gap: 6 }}>
                        {workspaceName}
                        <span style={{
                            fontSize: 9, fontWeight: 800, letterSpacing: 0.5, textTransform: 'uppercase',
                            background: 'var(--accent-glow)', color: 'var(--accent)', padding: '2px 6px', borderRadius: 99
                        }}>
                            {plan}
                        </span>
                    </div>
                </div>
            )}

            <div className="nav-section-label">Main</div>

            {NAV.map(({ to, label, icon: Icon }) => (
                <NavLink
                    key={to}
                    to={to}
                    className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                >
                    <Icon size={16} />
                    {label}
                </NavLink>
            ))}

            {/* Spacer */}
            <div style={{ flex: 1 }} />

            {/* AI status */}
            <div style={{
                margin: '0 0 8px',
                padding: '10px 12px',
                background: 'var(--accent-glow)',
                borderRadius: 'var(--radius-sm)',
                border: '1px solid rgba(108,71,255,0.2)',
                display: 'flex', alignItems: 'center', gap: 8
            }}>
                <Zap size={14} style={{ color: 'var(--accent)', flexShrink: 0 }} />
                <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--accent)' }}>AI Agent Active</div>
                    <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>Powered by Gemini 1.5</div>
                </div>
            </div>

            <button className="nav-item" onClick={handleLogout}>
                <LogOut size={16} />
                Sign out
            </button>
        </nav>
    )
}
